<template>
  <el-dialog
    width="600px"
    title="申请修改账单税率"
    :visible="visible"
    @close="$emit('update:visible', false)"
  >
    <el-form
      :model="editTaxRateForm"
      ref="editTaxRateForm"
      label-width="110px"
      label-position="right"
      width="300px"
    >
      <el-form-item label="税率%">
        <el-col :span="18">
          <el-input v-model="editTaxRateForm.taxRate" disabled></el-input>
        </el-col>
      </el-form-item>
      <el-form-item label="账期">
        <el-col :span="18">
          <el-input v-model="editTaxRateForm.periodMonth" disabled></el-input>
        </el-col>
      </el-form-item>
      <div style="margin-bottom: 15px; padding-left: 20px; line-height: 1.5em;">
        确定因为税率发生变更，需要按照最新税率重新计算账单，请先前往合作商平台及时修改税率（如果已修改可以跳过）。<br>

        <a target="_blank" href="https://bike.meituan.com/associate/cooperate/rate">https://bike.meituan.com/associate/cooperate/rate</a>，然后在此处点击“确定”按钮，<br>
        我们将通知骑行财务结算组撤回并修改账单。
      </div>
      <el-form-item>
        <el-col :span="8" :offset="16">
          <el-button @click="$emit('update:visible', false)">取消</el-button>
          <el-button type="primary" @click="onSubmit" :loading="isLoading">确定</el-button>
        </el-col>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
export default {
  name: 'editTaxRate',
  mixins: [],
  props: ['visible', 'curRow'],
  data() {
    return {
      isLoading: false,
      editTaxRateForm: {},
    }
  },
  computed: {},
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.editTaxRateForm = { ...this.curRow }
      this.$debugVue('v_editTaxRate', this)
    },
    // 获取信息
    onSubmit() {
      this.$refs.editTaxRateForm.validate(valid => {
        if (valid) {
          const params = {
            orderNo: this.curRow.orderId
          }
          this.loading = true
          this.fetch
            .get('reconcileBill_modifyTax', { params })
            .then(res => {
              this.loading = false
              const { message } = res || {}
              this.$message({
                type: 'success',
                message: message || '提交成功'
              })
              this.$emit('change')
              this.$emit('update:visible', false)
            })
            .catch(() => {
              this.loading = false
            })
        }
      })
    }
  }
}
</script>
